export class InventoryFilterRow {
  field: any;
  equalsValue: any = null;
  startsWithValue: any = null;
  greaterThenValue: any = null;
  smallerThenValue: any = null;
}
